import type { ComboboxItem } from '@mantine/core';
import { RelatedTasksMode } from './related-tasks-tab.type';

const RELATED_TASKS_MODE_OPTIONS: ComboboxItem[] = [
  { label: 'Contributing Tasks', value: RelatedTasksMode.ContributingTasks },
  { label: 'Contributing Epics', value: RelatedTasksMode.ContributingEpics },
  { label: 'Contributing Teams', value: RelatedTasksMode.ContributingTeams },
];

export { RELATED_TASKS_MODE_OPTIONS };
